import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import clsx from "clsx";

const InPlaceConfirmation = ({
  children,
  className,
  component,
  inProgress,
  onCancel,
  onConfirm,
  open,
  style,
  ...props
}) => {
  const ParentComponent = component || Box;
  return (
    <ParentComponent
      className={clsx(className, { InProgress: inProgress })}
      style={style}
    >
      <Slide in={open} direction="left" unmountOnExit>
        <Backdrop open={true} className="backdrop">
          <Grid container spacing={1}>
            <Grid>
              <Grid textAlign="center">
                <b>Are you sure?</b>
              </Grid>
              <Grid container spacing={2}>
                <Grid>
                  <IconButton onClick={onConfirm}>
                    <CheckIcon />
                  </IconButton>
                </Grid>
                <Grid>
                  <IconButton onClick={onCancel}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Backdrop>
      </Slide>
      <ParentComponent {...props} className={open ? "confirming" : ""}>
        {children}
      </ParentComponent>
    </ParentComponent>
  );
};

export default styled(InPlaceConfirmation)(
  ({ theme }) => `
  position: relative;
  background-color: ${theme.palette.background.paper};
  background-image: linear-gradient(rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15));
  padding: 0px;
  margin: 0px;

  .backdrop {
    margin: 0px;
    border-radius: 5px;
    position: absolute;
    z-index: 2;
  }

  .confirming {
    opacity: 0.3;
  }
`,
);
